import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';

const json = {
  1: {
    unit: 'Unit 12',
    id: 'WB4-V2-U12-P82-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 2,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page82/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page82/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page82/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page82/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E1/4.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E1/5.jpg' },

      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page82/E1/6.jpg' },

      ]
    ]
  },
  2: {
    unit: 'Unit 12',
    id: 'WB4-V2-U12-P82-E2',
    audio: 'img/FriendsPlus/Page82/Audio/audio-e2-p82.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 4,
    titleImage: '',
    exerciseKey: 'img/FriendsPlus/Page82/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page82/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page82/Audio/tieude-e2-p82.mp3' },
        { url: 'img/FriendsPlus/Page82/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page82/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page82/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page82/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/8.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/10.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page82/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page82/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page82/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/14.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page82/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/16.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page82/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/18.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E2/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page82/E2/20.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page82/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/22.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page82/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/24.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/26.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page82/E2/27.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page82/E2/28.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page82/E2/29.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/30.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page82/E2/31.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/32.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page82/E2/33.jpg' },
        { url: 'img/FriendsPlus/Page82/E2/34.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page82/E2/35.jpg' },
      ],

    ]
  },




}
export default json;